module.exports = __webpack_public_path__ + "img/pause.cf7eeaac.svg";